namespace $ {

	export class $hyoo_bunker_peer extends $hyoo_crus_entity.with({

		Secrets: $hyoo_crus_dict_to( $hyoo_crus_atom_ref_to( ()=> $hyoo_bunker_secret ) ),
		
	}){
		
	}
	
}
